import groq from 'groq';

export const OUR_VALUES_QUERY = groq`
  *[_type == "ourValues" && isActive == true][0]{
    _id,
    title,
    description,
    values[]{
      title,
      description,
      icon {
        asset->{
          _id,
          url,
          metadata {
            dimensions {
              width,
              height
            }
          }
        },
        alt
      },
      position
    },
    isActive
  }
`;

export const localizedOurValuesQuery = (locale: string) => groq`
  *[_type == "ourValues" && isActive == true][0]{
    _id,
    "title": title.${locale},
    "description": description.${locale},
    values[]{
      "title": title.${locale},
      "description": description.${locale},
      icon {
        asset->{
          _id,
          url,
          metadata {
            dimensions {
              width,
              height
            }
          }
        },
        alt
      },
      position
    },
    isActive
  }
`;
